import React from 'react'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"
import './css/demo.css'
import { Link } from 'react-router-dom'
export default function Demo() {
  return (
    <>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>Latest News</h1>
      
    </header>
    </div>
    <div className="container py-5">
  <div className="row">
    {/* Sidebar */}
    <aside className="col-lg-4 d-none d-lg-block border-end pe-4">
      {/* Sidebar Article 1 */}
      <div className="mb-4 sidebar-article">
        <Link to="news1">
        <img
          src="./images/AVIF.jpg"
          alt="Tax document review"
          className="fe2"
        />
        </Link>
        <Link to="news1" className='anchor'>
        <h5>Enron Egg” Reborn? Parody Company Unveils At-Home Nuclear Reactor</h5>
        </Link>
        <p className="text-muted">By Steve  | TSD Staff</p>
        
      </div>
      {/* Sidebar Article 2 */}
      <div className="mb-4 sidebar-article">
        <Link to="news1">
        <img
          src="./images/Fernando-perez.jpg"
          alt="Tax document review"
          className="fe2"
        />
        </Link>
        <Link to="news1" className='anchor'>
        <h5>Enron Egg” Reborn? Parody Company Unveils At-Home Nuclear Reactor</h5>
        </Link>
        <p className="text-muted">By Steve  | TSD Staff</p>
        
      </div>
    </aside>
    {/* Main Content */}
    <main className="col-lg-8">
      {/* Featured Article */}
      <div className="mb-5">
        <Link to="news3">
        <img
          src="./images/Softbank.jpg"
          alt="Business people in a hallway"
          className="fe1"
        />
        </Link>
        <Link to="news3" className='anchor'>
        <h1 className="fs-3 fw-bold">
        SoftBank Navigates Market Volatility Amid Strategic Shifts and AI Bets
        </h1>
        </Link>
        <p className="text-muted">By Kelly Phillips Erb | TSD Staff</p>
        
      </div>
      {/* Secondary Articles Grid */}
      <div className="row row-cols-1 row-cols-md-2 g-4">
        {/* Article 1 */}
        <div className="col">
          <div className="border-top pt-3">
            <Link to="news4">
            <img
              src="./images/PPIReport.jpg"
              alt="Capitol building"
              className="fe2"
            />
            </Link>
            <Link to="news4" className='anchor'>
            <h5>
            PPI Report Signals Cooling Inflation: What It Means for the Economy
            </h5>
            </Link>
            <p className="text-muted">By Kelly Phillips Erb | TSD Staff</p>
            
          </div>
        </div>
        {/* Article 2 */}
        <div className="col">
          <div className="border-top pt-3">
            <Link to="news5">
            <img
              src="./images/LA-Fires.jpg"
              alt="Stock market data"
              className="fe2"
            />
            </Link>
            <Link to="news5" className='anchor'>
            <h5>
            LA Fires Worsen Financial Strain as Costs Mount for Residents and Authorities
            </h5>
            </Link>
            <p className="text-muted">By Hank Tucker | TSD Staff</p>
            
          </div>
        </div>
      </div>
    </main>
    <header className="site-header">
    <h1></h1>
    <Link to="#" className="link-more">
      Load More »»
    </Link>
  </header>
  </div>
</div>
</>

  )
}
